import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  resources: [],
  catInfo: [],
  service: [],
  jobs: [],
  banner: [],
  relatedProds: [],
  relatedServices: [],
  gallery: [],
  page: [],
  team: [],
  testimonial: [],
  blogs: [],
  internships: [],
  sitesetting: [],
  domains: [],
  defaultAddress: "",
  defaultphones: "",
};

const commonSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setResources: (state, action) => {
      state.resources = action.payload;
    },
    setGallery: (state, action) => {
      state.gallery = action.payload;
    },
    setCurrentCategoryData: (state, action) => {
      state.catInfo = action.payload;
    },
    setRelatedProducts: (state, action) => {
      state.relatedProds = action.payload;
    },
    setService: (state, action) => {
      state.service = action.payload;
    },
    setBanner: (state, action) => {
      state.banner = action.payload;
    },
    setRelatedServices: (state, action) => {
      state.relatedServices = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setJobs: (state, action) => {
      state.jobs = action.payload;
    },
    setInternships: (state, action) => {
      state.internships = action.payload;
    },
    setTeam: (state, action) => {
      state.team = action.payload;
    },
    setTestimonial: (state, action) => {
      state.testimonial = action.payload;
    },
    setBlogs: (state, action) => {
      state.blogs = action.payload;
    },
    setsiteSetting: (state, action) => {
      state.sitesetting = action.payload;

      const data = action.payload?.siteSetting?.[0]?.data || {};
      const defaultAddr =
        data.addresses?.find((addr) => addr.isDefault)?.value || "";
      const defaultPhone =
        data.phones?.find((mob) => mob.isDefault)?.value || "";

      state.defaultAddress = defaultAddr;
      state.defaultphones = defaultPhone;
    },
    setDomains: (state, action) => {
      state.domains = action.payload;
    },
  },
});

export const {
  setProducts,
  setResources,
  setServices,
  setGallery,
  setBanner,
  setCurrentCategoryData,
  setRelatedProducts,
  setRelatedServices,
  setPage,
  setService,
  setJobs,
  setInternships,
  setTeam,
  setTestimonial,
  setBlogs,
  setsiteSetting,
  setDomains,
} = commonSlice.actions;

export default commonSlice.reducer;
